"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.format = format;
exports.formatUtc = formatUtc;
exports.toEpochMilliseconds = toEpochMilliseconds;
exports.toEpochSeconds = toEpochSeconds;
exports.toUtcEpochMilliseconds = toUtcEpochMilliseconds;
exports.toUtcEpochSeconds = toUtcEpochSeconds;
var _moment = _interopRequireDefault(require("moment"));
var _LangUtils = require("./LangUtils");
function format(d, inputFormat, outputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? (0, _moment.default)(d).format(outputFormat) : (0, _moment.default)(d, inputFormat).format(outputFormat);
}
function formatUtc(d, inputFormat, outputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? _moment.default.utc(d).format(outputFormat) : _moment.default.utc(d, inputFormat).format(outputFormat);
}
function toEpochSeconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? (0, _moment.default)(d).unix() : (0, _moment.default)(d, inputFormat).unix();
}
function toUtcEpochSeconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? _moment.default.utc(d).unix() : _moment.default.utc(d, inputFormat).unix();
}
function toEpochMilliseconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? (0, _moment.default)(d).valueOf() : (0, _moment.default)(d, inputFormat).valueOf();
}
function toUtcEpochMilliseconds(d, inputFormat) {
  return (0, _LangUtils.isEmpty)(inputFormat) ? _moment.default.utc(d).valueOf() : _moment.default.urc(d, inputFormat).valueOf();
}
var _default = {
  format,
  formatUtc,
  toEpochMilliseconds,
  toEpochSeconds,
  toUtcEpochMilliseconds,
  toUtcEpochSeconds
};
exports.default = _default;